import { render } from "./LicensePageMetaContentIndicator.vue?vue&type=template&id=f9fed52a&ts=true"
import script from "./LicensePageMetaContentIndicator.vue?vue&type=script&lang=ts"
export * from "./LicensePageMetaContentIndicator.vue?vue&type=script&lang=ts"

import "./LicensePageMetaContentIndicator.vue?vue&type=style&index=0&id=f9fed52a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__